import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Wrapper, Logo, Right, Icon } from './style';
import LogoImg from '../../assets/intro/Full color.svg';
import * as UIActions from '../../redux/actions/UI';
import Backdrop from '../Helpers/Backdrop/Backdrop';
import IconMenu from '../../assets/ImgComponents/IconMenu';

const Header = ({ backdropState, toggleGralBKdrop, setSidebarState, sidebarState }) => {
  const history = useHistory();
  const bkdropOnClick = () => toggleGralBKdrop(false);

  const toggleSidebar = () => {
    setSidebarState(true);
    toggleGralBKdrop(true);
  };

  return (
    <>
      <Wrapper>
        <Logo src={LogoImg} alt="Logo" onClick={() => history.push('/')} />
        <Right>
          <Icon onClick={toggleSidebar}>
            <IconMenu />
          </Icon>
        </Right>
      </Wrapper>
      <Backdrop isOpen={backdropState} handleClick={bkdropOnClick} zIndex={1000} />
    </>
  );
};

const mapStateToProps = ({ UI }) => ({
  backdropState: UI.showBkDrop,
  sidebarState: UI.sidebarState,
});

const mapDispatchToProps = dispatch => ({
  toggleGralBKdrop: state => dispatch(UIActions.setBKDrop(state)),
  setSidebarState: state => dispatch(UIActions.setSidebarState(state)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);
